import ShareLinksPresentation from 'components/ShareLinks/ShareLinksPresentation'

export default {
  Presentation: ShareLinksPresentation,
}
